















import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../App.css";
import BASE_URL from '../utils/Urls';


export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const sessionActive = localStorage.getItem("sessionActive");
    if (!sessionActive) {
      localStorage.removeItem("jwtToken");
    }
    const handleBeforeUnload = () => {
      localStorage.removeItem("sessionActive");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(`${BASE_URL}/login`, {
        username,
        password,
      });

      const { token, user } = res.data;

      localStorage.setItem("jwtToken", token);
      localStorage.setItem("sessionActive", "true");
      localStorage.setItem("loggedInUser", JSON.stringify(user));

      alert("✅ Login Successful!");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.data?.message || "❌ Something went wrong. Try again."
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center fixed inset-0 overflow-hidden">
      <div className="card">
        <span className="login">Log in</span>

        <form onSubmit={handleLogin} className="flex flex-col items-center gap-6">
          <div className="inputBox">
            <input
              type="text"
              required="required"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <span className="user">Username</span>
          </div>

          <div className="inputBox">
            <input
              type="password"
              required="required"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span>Password</span>
          </div>

          {error && <p style={{ color: "red", fontSize: "12px" }}>{error}</p>}

          <button type="submit" className="enter">
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}
